import { ObjetKForm, requiredRule, combineRules, enumValue } from '@siclop/kstone-vue'
import { ContractType } from '../enums/ContractType'
import type { Employee } from '../models/Employee'
import { PersonForm } from '@siclop/ksadmin-vue'

/**
 * Form for editing an employee
 */
export class EmployeeForm extends ObjetKForm {
  personId: number = 0
  person: PersonForm = new PersonForm()
  organizationId: number = 0
  professionId?: number
  hireDate: string = ''
  terminationDate?: string | null
  salary: number = 0
  /** Coût horaire (€) : saisi sans la paie, calculé depuis le salaire avec elle. */
  hourlyCost: number | null = null
  contractType: ContractType = ContractType.CDI
  workingHoursPerWeek: number = 35
  workScheduleTemplateId: number | null = null
  positionStartDate: string | null = null
  /** Mode de calcul des RTT propre au salarié ; null : celui de l'entreprise (0 = « Aucun », à ne pas confondre). */
  rttMode: number | null = null

  constructor(data?: Partial<Employee>) {
    super(data)
    if (data) {
      this.personId = data.personId ?? 0
      this.person = data.person ? new PersonForm(data.person) : new PersonForm()
      this.organizationId = data.organizationId ?? 0
      this.professionId = data.professionId
      this.hireDate = data.hireDate ?? ''
      this.terminationDate = data.terminationDate
      this.salary = data.salary ?? 0
      this.hourlyCost = data.hourlyCost ?? null
      this.contractType = enumValue(ContractType, data.contractType, ContractType.CDI)
      this.workingHoursPerWeek = data.workingHoursPerWeek ?? 35
      this.workScheduleTemplateId = data.workScheduleTemplateId ?? null
      this.positionStartDate = data.positionStartDate ?? null
      this.rttMode = data.rttMode ?? null
    }
  }

  static validationRules = {
    'person.lastName': combineRules(requiredRule('Le nom est obligatoire')),
    organizationId: combineRules(requiredRule("L'organisation est obligatoire")),
    hireDate: combineRules(requiredRule("La date d'embauche est obligatoire")),
    contractType: combineRules(requiredRule('Le type de contrat est obligatoire'))
  }

  /**
   * Convert to JSON for API submission
   */
  toJSON(): Record<string, unknown> {
    return {
      id: this.id,
      personId: this.personId,
      person: {
        id: this.person.id,
        firstName: this.person.firstName,
        lastName: this.person.lastName
      },
      organizationId: this.organizationId,
      professionId: this.professionId,
      hireDate: this.hireDate,
      terminationDate: this.terminationDate,
      salary: this.salary,
      hourlyCost: this.hourlyCost ?? null,
      contractType: this.contractType,
      workingHoursPerWeek: this.workingHoursPerWeek,
      workScheduleTemplateId: this.workScheduleTemplateId ?? null,
      positionStartDate: this.positionStartDate ?? null,
      rttMode: this.rttMode ?? null
    }
  }
}
